import { useProducts, type ProductSummary } from '@/contexts/ProductsContext';

export type { ProductSummary };

/** Mapa productId → resumo (nome, avatar) para células e chips. */
export function useProductsMap(): Map<string, ProductSummary> {
  const { productsById } = useProducts();
  return productsById;
}
